import React from "react";
import { Route, Switch } from "react-router-dom";
import MaintenanceReminders from "./MaintenanceReminders";
import Renewals from "./Renewals";
import DocumentRenewals from "./DocumentRenewals";

export default () => (
  <Switch>
    <Route
      path="/reminders/maintenancereminders"
      component={MaintenanceReminders}
    />
    <Route path="/reminders/renewals" component={Renewals} />
    <Route path="/reminders/documentrenewals" component={DocumentRenewals} />
  </Switch>
);
